import { ExpenseClaim, ExpenseClaimDetail } from 'domain-types';

/**
 * Uses the actual expense submission timestamp when a saved draft was submitted
 * later, while falling back to the original creation timestamp for direct
 * submissions and older claims without submittedAt.
 */
export const getExpenseClaimDisplayDate = (
  claim: Pick<ExpenseClaim | ExpenseClaimDetail, 'createdAt' | 'submittedAt'>
) => claim.submittedAt ?? claim.createdAt;
